import { SearchScenarioId } from 'owa-search';

export default function isFileSuggestionsSearchAction(scenarioId: SearchScenarioId): boolean {
    return scenarioId === SearchScenarioId.FileSuggestions;
}
